<ng-template
  #hiddenDays
  let-days="days">
  <div class="hidden-days">
    <div
      class="hidden-day"
      *ngFor="let day of days"
      [class.is-first-week-day]="
        day.totalIndex === 0 || (day.date | date: 'cc') === '1'
      "
      [class.weekday-saturday]="(day.date | date: 'cc') === '6'"
      [class.last-day-of-month]="day.date | lastOfMonth"
      [class.selected]="
        activeDayIndex !== undefined &&
        (day.totalIndex === activeDayIndex ||
          (day.totalIndex > activeDayIndex &&
            day.totalIndex <= activeDayIndex + (activeDayRange || 0)))
      "
      [class.is-today]="
        (day.date | date: 'yyyy.MM.dd') == today &&
        (calendarTableHelper?.start | date: 'yyyy.MM.dd') !== today
      "></div>
  </div>
</ng-template>
<app-custom-table-header class="table-header-row">
  <app-custom-table-cell class="sticky-header-cell-left header-label-cell">
  </app-custom-table-cell>
  <div class="header-rows">
    <div class="months-wrapper">
      <ng-container *ngFor="let monthGroup of calendarTableHelper?.months">
        <div class="month-wrapper">
          <div
            class="month-name"
            *ngIf="monthGroup.days.length > 2">
            {{ monthGroup.days[0].date | date: "MMMM yyyy" }}
          </div>
          <ng-container
            [ngTemplateOutlet]="hiddenDays"
            [ngTemplateOutletContext]="{ days: monthGroup.days }">
          </ng-container>
        </div>
      </ng-container>
    </div>
    <div class="weeks-wrapper">
      <ng-container *ngFor="let weekGroup of calendarTableHelper?.weeks">
        <div class="week-wrapper">
          <div class="calendar-week">
            {{ "KW" + " " + (weekGroup.days[0].date | date: "ww") }}
          </div>
          <ng-container
            [ngTemplateOutlet]="hiddenDays"
            [ngTemplateOutletContext]="{ days: weekGroup.days }">
          </ng-container>
        </div>
      </ng-container>
    </div>
    <div class="days-wrapper">
      <ng-container
        *ngFor="let day of calendarTableHelper?.days; let dayIndex = index">
        <app-custom-table-cell
          [class.selected]="
            activeDayIndex !== undefined &&
            (dayIndex === activeDayIndex ||
              (dayIndex > activeDayIndex &&
                dayIndex <= activeDayIndex + (activeDayRange || 0)))
          "
          class="date-header-cell"
          [class.clickable]="daySelectable"
          [class.is-first-week-day]="
            dayIndex === 0 || (day | date: 'cc') === '1'
          "
          [class.weekday-saturday]="(day | date: 'cc') === '6'"
          [class.last-day-of-month]="day | lastOfMonth"
          [class.is-today]="
            (day | date: 'yyyy.MM.dd') == today &&
            (calendarTableHelper?.start | date: 'yyyy.MM.dd') !== today
          "
          (click)="selectDay(dayIndex)">
          <div class="highlight-container">
            <div>
              {{ day | date: "dd" }}
            </div>
            <div class="week-day">
              {{ (day | date: "EEEE")?.slice(0, 2) }}
            </div>
          </div>
        </app-custom-table-cell>
      </ng-container>
    </div>
  </div>
</app-custom-table-header>
